/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'fabric.linkPicker.button.cancel': 'Abbrechen',
  'fabric.linkPicker.button.insert': 'Einfügen',
  'fabric.linkPicker.button.save': 'Speichern',
  'fabric.linkPicker.clearLink': 'Löschen',
  'fabric.linkPicker.clearLinkText': 'Text löschen',
  'fabric.linkPicker.hyperlink.searchLinkResults':
    '{count, plural, =0 {Keine Ergebnisse gefunden} one {{count,number} Ergebnis gefunden} other {{count,number} Ergebnisse gefunden}}',
  'fabric.linkPicker.linkAriaLabel': 'Geben Sie einen Link in das Feld ein oder kopieren Sie einen hinein',
  'fabric.linkPicker.linkHelperTextAriaLabel': 'Hilfstext zur Linkanzeige',
  'fabric.linkPicker.linkHelperTextLabel': 'Geben Sie diesem Link einen Titel oder eine Beschreibung',
  'fabric.linkPicker.linkInvalid': 'Geben Sie eine gültige URL ein.',
  'fabric.linkPicker.linkLabel': 'Verknüpfung',
  'fabric.linkPicker.linkPlaceholder': 'Link einfügen',
  'fabric.linkPicker.linkTextAriaLabel': 'Anzeigetext des Links',
  'fabric.linkPicker.linkTextLabel': 'Anzeigetext (optional)',
  'fabric.linkPicker.linkTextPlaceholder': 'Text zum Anzeigen',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Kürzlich angesehen',
  'fabric.linkPicker.listTitle.results': 'Ergebnisse',
  'fabric.linkPicker.noEmbed':
    'Die eingebettete Ansicht wird für diesen Link nicht unterstützt. <a>Weitere Informationen dazu, warum manche intelligente Links keinen Inhalt anzeigen</a>',
  'fabric.linkPicker.search.error.description':
    'Laden Sie die Seite erneut oder wenden Sie sich an den <a>Atlassian Support</a>, falls das Problem weiterhin besteht.',
  'fabric.linkPicker.search.error.heading': 'Beim Laden dieser Daten ist ein Problem aufgetreten.',
  'fabric.linkPicker.search.error.retry': 'Neu laden',
  'fabric.linkPicker.search.linkAriaLabel': 'Während Ihrer Eingabe in das Feld werden unten Vorschläge angezeigt',
  'fabric.linkPicker.search.linkLabel': 'Link suchen oder einfügen',
  'fabric.linkPicker.search.linkPlaceholder': 'Aktuelle Links finden oder neuen Link einfügen',
  'fabric.linkPicker.search.noResults.description': 'Versuchen Sie es mit einem anderen Begriff erneut.',
  'fabric.linkPicker.search.noResults.heading':
    'Es wurden keine passenden Ergebnisse gefunden, die mit Ihrem Suchbegriff übereinstimmen.',
  'fabric.linkPicker.status.submitting': 'Wird gesendet',
  'fabric.linkPicker.time.message.updated': 'Aktualisiert: {time}',
  'fabric.linkPicker.time.message.viewed': 'Angesehen: {time}',
  'fabric.linkPicker.unhandledError.description': 'Versuchen Sie, die Seite neu zu laden.',
  'fabric.linkPicker.unhandledError.heading': 'Etwas ist schiefgelaufen!',
};
